import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import './style.css';
import useNavegacao from '../../hooks/useNavegacao';
import { Button } from 'primereact/button';

export default function ModalPlanoDesativado({ status, plano, cidade, inscricao, mostrarFooter, closable }){
    const [visible, setVisible] = useState(!status);

    const { navegarParaEditarContrato, navegarParaListaContratos } = useNavegacao();

    const footer = (
        <>
            {mostrarFooter && <><Button
                label="Ir para editar contrato"
                onClick={() => navegarParaEditarContrato(inscricao)}
            />
            <Button
                label="voltar"
                onClick={navegarParaListaContratos}
            /> </>}
        </>
    );

    return (
        <Dialog
            visible={visible}
            onHide={()=>setVisible(false)}
            header={'Atenção!'}
            footer={footer}
            closable={closable}
        >
            <p>Plano {plano} está <span className="mensagem-erro-plano-desativado">desativado </span>para a cidade {cidade}. Necessário mudar para um plano ativo.</p>

        </Dialog>
    );
}
